// Webpack Imports
import * as bootstrap from 'bootstrap';
import * as $ from 'jquery';


( function () {
	'use strict';
// TODO: Clean up code below
	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

$('input[type=radio][name=resourceSelect]').change(function() {
	if (this.value == 'hcp') {
	  $('#patient-resources').fadeOut().hide();
	  $('#hcp-resources').fadeIn().show();
	} else {
	  $('#hcp-resources').fadeOut().hide();
	  $('#patient-resources').fadeIn().show();
	}
});

$('#orderSubmit').on("click", function () {
	var kitVal = $('input[name="kit"]:checked').val();
	var pageName = $(this).data("page-name");
	var errorMessage = $(this).data("error-msg");
	if (!kitVal) {
		alert(errorMessage);
	} else {
		window.location = '/'+pageName+'/?kit=' + kitVal;
	}
	return false;
});

$('.kit-select').on("change", function () {
	var currentSelection = $(this).val();
	$('input[name="input_6"]').val(currentSelection);
});

jQuery.noConflict();
   jQuery(document).ready(function($) {
	var italicField = $(".italics label:lang(fr-FR)")
	var copy = italicField.html();
	if (copy) {
		copy = copy.replace("Drug Identification Number", "<em>Drug Identification Number</em>");
		italicField.html(copy);
	}
   });

   // 